import { CartItem, PrePurchasedItem, TicketUpgradeDataModel } from "../models";
import {
  convertDataToCartItemFlattened,
  convertPrePurchasedItemToCartItem,
} from "./DataConverters";
import { getTotalPriceForProductOptions } from "./Modifier";
import { findSimilarProduct } from "./Product";
import { isTicket } from "./Ticket";
import { filterUpgradedRedeemingTickets } from "./TicketUpgrade";

export const sortDataWithTicketsOnTop = (
  data: (CartItem | PrePurchasedItem)[]
) => {
  return [...data].sort(
    (a: PrePurchasedItem | CartItem, b: PrePurchasedItem | CartItem) => {
      if (isTicket(a) && !isTicket(b)) {
        return -1;
      }
      if (!isTicket(a) && isTicket(b)) {
        return 1;
      }
      return a.type?.localeCompare(b.type);
    }
  );
};

export const mergeSimilarProducts = (
  data: (CartItem | PrePurchasedItem)[],
  includePrice = true,
  includeUpgradedCartTicket = true
) => {
  const mergedData: (CartItem | PrePurchasedItem)[] = [];
  data.forEach((item: CartItem | PrePurchasedItem) => {
    const existingProduct = findSimilarProduct(
      mergedData,
      item,
      includePrice,
      false,
      includeUpgradedCartTicket
    ) as typeof item;

    if (existingProduct) {
      // Create a shallow copy of the existing product
      const updatedProduct = {
        ...existingProduct,
        quantity: existingProduct.quantity + item.quantity,
      };
      const existingProductIndex = mergedData.indexOf(existingProduct);
      mergedData[existingProductIndex] = updatedProduct;
    } else {
      mergedData.push({ ...item });
    }
  });

  return mergedData;
};

export const flattenedItemForRedemption = (
  itemsForRedemption: PrePurchasedItem[],
  ticketUpgradeData: TicketUpgradeDataModel[]
) => {
  const allFlattenedData: PrePurchasedItem[] = [];

  sortDataWithTicketsOnTop(
    mergeSimilarProducts(
      filterUpgradedRedeemingTickets(itemsForRedemption, ticketUpgradeData),
      true
    )
  ).flatMap((item: PrePurchasedItem) => {
    if (!item.productOptions || item.productOptions.length === 0) {
      allFlattenedData.push({
        ...item,
      });
    } else if (
      item.productOptions &&
      getTotalPriceForProductOptions(item.productOptions) === 0
    ) {
      allFlattenedData.push({
        ...item,
      });
    }
  });

  return allFlattenedData;
};

export const flattenedItemsInCart = (
  itemsInCart: CartItem[],
  itemsForRedemption: PrePurchasedItem[]
) => {
  const allFlattenedData = convertDataToCartItemFlattened(itemsInCart);

  mergeSimilarProducts(itemsForRedemption).flatMap((item: CartItem) => {
    if (
      item.productOptions &&
      getTotalPriceForProductOptions(item.productOptions) !== 0
    ) {
      allFlattenedData.push({
        ...convertPrePurchasedItemToCartItem(item),
      });
    }
  });

  return allFlattenedData;
};
